// extracted by mini-css-extract-plugin
export default {"wrapper":"styles__wrapper___B5mCD","innerWrapper":"styles__innerWrapper___r0607","fullWidth":"styles__fullWidth___Sj5KV"};